import React from 'react';
import { withRouter } from 'react-router';
import { Alert, Modal, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { PageStatus } from 'enums';
import { Show } from 'Layout';
import { SurveysAPI } from "../../API";
import { Confirmation } from "../../Shared/Confirmation";
import moment from "moment";

type State = {
  survey: any,
  status: string,
  error: string | null,
};


class Details extends React.Component<any, State> {
  // Hey! sonarqube, Please ignore this code
  // static defaultProps = {
  //   languageId: null,
  //   hideMenu: false,
  //   onUpdate: () => null,
  // };

  constructor(props) {
    super(props);
    this.state = {
      survey: null,
      status: PageStatus.None,
      error: null,
    };
  }

  componentDidMount() {
    if (this.props.id) {
      this.fetchSurvey();
    }
  }

  fetchSurvey() {
    Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Loading }))
      .then(() => {
        if (!this.props.id) {
          return Promise.reject(new Error('Invalid ID'));
        }
        return SurveysAPI.getOne(this.props.id);
      })
      .then((respoData) => {
        if (respoData) {
          let survey = respoData.data;
          this.setState({ survey, status: PageStatus.Loaded });
        }
      })
      .catch((error) => {
        this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  onDelete() {
    Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Loading }))
      .then(() => {
        if (!this.props.id) {
          return Promise.reject(new Error('Invalid ID'));
        }
        return SurveysAPI.deleteOne(this.props.id);
      })
      .then((country) => {
        this.setState({ status: PageStatus.Loaded });
        return this.props.onDelete()

      })
      .catch((error) => {
        this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  render() {
    const sendSurveyTpByValue = (): string => {
      let exArray: string[] = [];
      if (this.state.survey?.sms === "Y") exArray.push("SMS");
      if (this.state.survey?.whatsapp === "Y") exArray.push("Whats-App");
      if (this.state.survey?.email === "Y") exArray.push("Email");
      return exArray.join(", ");
    }
    const showSurveysTpStatus = (type) => {
      let obj = {
        "Open": "Live",
        "Hold": "On Hold",
        "Wait": "Ids Awaited",
        "Close": "End",
        "Test": "Test",
      };
      return obj[type] ?? "";
    }
    const setYNinRespoField = (cond) => { if (cond) { return "Yes" } return "No"; }
    return (
      <Modal
        centered
        size="lg"
        backdrop="static"
        onHide={this.props.onClose}
        show
        style={{ zIndex: 1201 }}
      >
        <Modal.Header closeButton>
          <h5 className="mb-0 mt-1">Details</h5>
          <div
            className="d-flex justify-content-end w-100 mr-2"
          >
            <button
              type="button"
              onClick={() => this.props.onUpdate()}
              className="btn-sm btn-primary mr-2"
            >
              <FontAwesomeIcon
                icon={['fas', 'edit']}
                className="mr-2"
              />
              Update
            </button>
            <Confirmation onAction={() => this.onDelete()} body="Are you sure want to delete ?">
              <button
                type="button"
                title="End the call"
                className="btn call-end"
              >
                <FontAwesomeIcon
                  icon={['fas', 'trash']}
                  className="mr-2"
                />
              </button>
            </Confirmation>
          </div>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>

          <Show when={this.state.status === PageStatus.Loading}>
            <div className="d-flex justify-content-center w-100 p-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Show>

          <Show when={this.state.status === PageStatus.Loaded && !!this.state.survey}>
            <div className="row mt-2">
              <div className="col">
                <strong>Name: </strong>
                {this.state.survey?.name}
              </div>
              <div className="col">
                <strong>Company: </strong>
                {this.state.survey?.company}
              </div>
            </div>

            {(this.state.survey?.parentid &&
              <div className="row mt-2">
                <div className="col">
                  <strong>Parent Id: </strong>
                  {this.state.survey?.parentid}
                </div>
                <div className="col"></div>
              </div>
            )}

            <div className="row mt-2">
              <div className="col">
                <strong>Project Name: </strong>
                {this.state.survey?.projectname}
              </div>
              <div className="col">
                <strong>Project Id: </strong>
                {this.state.survey?.projectId}
              </div>
            </div>

            <div className="row mt-2">
              <div className="col">
                <strong>Survey UUID: </strong>
                {this.state.survey?.id}
              </div>
              <div className="col">
                <strong>Start-End IP Validated: </strong>
                {setYNinRespoField(this.state.survey?.validateStartEndIp === "Y")}
              </div>
            </div>

            <div className="row mt-2">
              <div className="col">
                <strong>Country Validated: </strong>
                {setYNinRespoField(this.state.survey?.validateCountry === "Y")}
              </div>
              <div className="col">
                <strong>Test URL: </strong>
                <a href={this.state.survey?.testurl} target="_blank" rel="noopener noreferrer">
                  {this.state.survey?.testurl}
                </a>
              </div>
            </div>

            <div className="row mt-2">
              <div className="col">
                <strong>Description: </strong>
                {this.state.survey?.description}
              </div>
              <div className="col">
                <strong>Live URL: </strong>
                <a href={this.state.survey?.url} target="_blank" rel="noopener noreferrer">
                  {this.state.survey?.url}
                </a>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <strong>Survey Length: </strong>
                {this.state.survey?.surveyLength}
              </div>
              <div className="col">
                <strong>Complete Points: </strong>
                {this.state.survey?.ceggPoints}
              </div>
            </div>

            <div className="row mt-2">
              <div className="col">
                <strong>Over Quota Points: </strong>
                {this.state.survey?.overquota}
              </div>
              <div className="col">
                <strong>Terminate Points: </strong>
                {this.state.survey?.terminate}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <strong>Quality Terminate Points: </strong>
                {this.state.survey?.qualityterminate}
              </div>
              <div className="col">
                <strong>PM Name: </strong>
                {this.state.survey?.pmName}
              </div>
            </div>

            <div className="row mt-2">
              <div className="col">
                <strong>Start Date: </strong>
                {moment(this.state.survey?.createdAt).format('MM/DD/YYYY HH:mm A')}
              </div>
              <div className="col">
                <strong>End Date: </strong>
                {moment(this.state.survey?.expiryDate).format('MM/DD/YYYY HH:mm A')}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <strong>Client Quota: </strong>
                {this.state.survey?.userLimitCommitted}
              </div>
              <div className="col">
                <strong>Survey Status: </strong>
                {showSurveysTpStatus(this.state.survey?.surveyType)}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <strong>Point Allocation Type: </strong>
                {this.state.survey?.pointAllocationType}
              </div>
              <div className="col">
                <strong>Client: </strong>
                {this.state.survey?.client}
              </div>
            </div>

            <div className="row mt-2">
              <div className="col">
                <strong>IPolls Quota: </strong>
                {this.state.survey?.country == "India" ? this.state.survey?.userLimitCutoff : 0}
              </div>
              <div className="col">
                <strong>Company Logo: </strong>
                <img src={(this.state.survey?.companyLogo && this.state.survey?.companyLogo != "") ? this.state.survey?.companyLogo : "/assets/img/logo-white.png"} style={{ width: '50px', height: '40px', backgroundColor: "black", objectFit: "contain" }} alt='...Logo'/>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <strong>Speeder Limit (In minutes): </strong>
                {this.state.survey?.outlierCutoffTime}
              </div>
              <div className="col">
                <strong>Cost Per Interview: </strong>
                {this.state.survey?.currency ?? ""}
                {this.state.survey?.costPerInterview}
              </div>
            </div>

            <div className="row mt-2">
              <div className="col">
                <strong>Use Unique Links: </strong>
                {setYNinRespoField(this.state.survey?.useUniqueLinks)}
              </div>
              <div className="col">
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <strong>IP Unique: </strong>
                {setYNinRespoField(this.state.survey?.ipUnique)}
              </div>
              <div className="col">
                <strong>Survey URL Identifier: </strong>
                {this.state.survey?.surveyUrlIdentifier}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <strong>Client IR: </strong>
                {this.state.survey?.clientir ?? "N.A."}
              </div>
              <div className="col">
                <strong>Send Survey By: </strong>
                {sendSurveyTpByValue()}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <strong>Country: </strong>
                {this.state.survey?.country ?? "N.A."}
              </div>
            </div>
            <div className="row mt-2">
              <div className="col">
                <strong>Disclaimer: </strong>
                <span dangerouslySetInnerHTML={{
                  __html: this.state.survey?.disclaimer || 'Title',
                }} />
              </div>
            </div>
            <Alert
              variant="danger"
              show={this.state.status === PageStatus.Error}
            >
              {this.state.error}
            </Alert>
          </Show>
        </Modal.Body>
      </Modal>
    );
  }
}

const DetailsWithRouter = withRouter(Details);

export { DetailsWithRouter as Details };
